export default __webpack_public_path__ + "static/media/enoperacion.b8b69060.svg";